<template>
  <div class="white-container full-page-container common-table equipment-page">
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item label="是否新品" class="search-form-item search-form-item-small">
        <el-select v-model="search.newFlag" placeholder="全部">
          <el-option label="全部" value="" />
          <el-option v-for="item in statusList" :key="item.id" :label="item.value" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="是否热卖" class="search-form-item search-form-item-small">
        <el-select v-model="search.isHot" placeholder="全部">
          <el-option label="全部" value="" />
          <el-option v-for="item in statusList" :key="item.id" :label="item.value" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item class="search-form-item" label="库存">
        <RangeInput :start.sync="search.qtyRangeStart" :end.sync="search.qtyRangeEnd" />
      </el-form-item>
      <el-form-item class="search-form-item" label="销量">
        <RangeInput :start.sync="search.soldQtyRangeStart" :end.sync="search.soldQtyRangeEnd" />
      </el-form-item>
      <el-form-item class="search-form-item search-sku">
        <el-input v-model="search.keyword" placeholder="输入商品SKU或商品名称" prefix-icon="el-icon-search" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div ref="tableBox" class="activity-table">
      <tableList ref="multipleTable" size="small" :table-query="search" :query-function="$Api.equipment.postEquipmentList" style="width: 100%" @sort-change="sortChangeHandle">
        <el-table-column prop="productNo" label="商品SKU" />
        <el-table-column prop="productName" label="商品名称" />
        <el-table-column prop="categories" label="分类">
          <template v-slot="{ row }">
            <template v-if="row.categories">
              <div v-for="item in row.categories.split('，')" :key="item">{{ item }}</div>
            </template>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column prop="newFlag" label="是否新品">
          <template v-slot="{ row }">
            {{ row.newFlag === 1 ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column prop="mediaLink" label="商品图片">
          <template v-slot="{ row }">
            <div class="img-box" style="width:75px; height: 75px">
              <img v-if="row.isDelete === 1" class="invalid-flag" src="@/assets/images/product-invalid.svg">
              <img v-if="row.mediaLink" class="product-img" :src="row.mediaLink" alt="">
              <div v-else style="line-height: 75px;">--</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="qty" label="库存" sortable="custom" :sort-orders="['descending', 'ascending']" />
        <el-table-column prop="soldQty" label="销量" sortable="custom" :sort-orders="['descending', 'ascending']" />
        <el-table-column prop="isHot" label="是否热卖商品">
          <template v-slot="{ row }">
            {{ row.isHot === 1 ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="{row}">
            <el-button size="small" type="text" class="link-color" @click="copyLink(row)">复制EC商品链接</el-button>
          </template>
        </el-table-column>
      </tableList>
    </div>
  </div>
</template>
<script>
import tableList from "@/components/TableList";
import RangeInput from "@/components/RangeInput";

export default {
  components: {
    tableList,
    RangeInput,
  },
  data() {
    return {
      excel: null, // 商品文件
      excelName: '', // 以及上传的商品文件名
      photos: [], // 商品图片
      fileList: [], // 商品图片列表
      search: {
        keyword: "",
        newFlag: "",
        isHot: "",
        qtyRangeStart: "",
        qtyRangeEnd: "",
        soldQtyRangeStart: "",
        soldQtyRangeEnd: "",
      },
      statusList: [
        { id: 1, value: '是' },
        { id: 0, value: '否' },
      ],
    };
  },
  mounted() {
    this.params = {
      qtySort: null,
      soldQtySort: null,
    };
  },
  methods: {
    searchSubmit() {
      this.$refs['multipleTable'].searchAndReset(this.params);
    },
    reset() {
      this.search = this.$options.data.call(this).search;
      this.$refs.multipleTable.getEl().clearSort();
      this.params = {
        qtySort: null,
        soldQtySort: null,
      };
      this.$nextTick(() => {
        this.$refs['multipleTable'].searchAndReset(this.params);
      });
    },
    copyLink(row) {
      const linkto = row.linkTo;
      navigator.clipboard.writeText(linkto).then(() => {
        this.$message.success('复制成功');
      }).catch(() => {
        this.$message.error('复制失败');
      });
    },
    sortChangeHandle({ prop, order }) {
      const keyMap = {
        qty: 'qtySort',
        soldQty: 'soldQtySort',
      };
      if (!keyMap[prop]) return;
      const orderMap = {
        descending: false,
        ascending: true,
      };
      this.params = {
        qtySort: keyMap[prop] !== 'qtySort' ? null : orderMap[order],
        soldQtySort: keyMap[prop] !== 'soldQtySort' ? null : orderMap[order],
      };
      this.$refs['multipleTable'].searchAndReset(this.params);
    },
  },
};
</script>

<style lang="less" scoped>
.search-form-item-small {
  /deep/ .el-form-item__content {
    width: 100px;
  }
}
.search-sku {
  /deep/ .el-form-item__content {
    width: 150px;
  }
}
.flex-wrap {
  display: flex;
}
.placeholder {
  margin: 0 8px;
}
.product-img {
  width: 100%;
  height: 100%;
}
.equipment-page {
  .operation-bar {
    line-height: 2;
  }
  .el-dialog__wrapper {
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    /deep/ .up-wrapper {
      width: 538px;
      .el-dialog__header {
        height: 6.85vh !important;
        line-height: 6.85vh;
        padding: 0 2.87vh 0 2.78vh !important;
        background: #000000 !important;
        box-sizing: border-box !important;
        .el-dialog__title {
          font-family: "Noto Sans SC";
          font-style: normal;
          font-weight: 500;
          font-size: 1.48vh;
          color: #ffffff;
        }
        .el-dialog__headerbtn {
          top: 2.87vh;
          right: 2.87vh;
          font-size: 1.11vh;
          .el-dialog__close {
            color: #ffffff;
            &:hover {
              color: #dc0019;
            }
          }
        }
      }
      .el-dialog__body {
        padding: 20px;
        .warn-tips {
          display: flex;
          align-items: center;
          padding: 5px 10px;
          width: 100%;
          height: 30px;
          background: #caa670;
          border-radius: 4px;
          color: #fff;
          margin-bottom: 20px;
        }
        .temp-wrap {
          height: 114px;
          background: #f7f7f7;
          border: 1px dashed #bbbbbb;
          border-radius: 4px;
          padding: 20px 30px;
          box-sizing: border-box;
          margin-bottom: 20px;
          .el-button {
            margin-top: 20px;
          }
        }
        .upload-wrap {
          width: 100%;
          height: 236px;
          background: #f7f7f7;
          border: 1px dashed #bbbbbb;
          border-radius: 4px;
          padding: 20px 30px;
          box-sizing: border-box;
          .el-upload-dragger {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .tips {
            font-family: "Noto Sans SC";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #494949;
            margin-bottom: 20px;
          }
          .upload-box {
            width: 100%;
            height: 156px;
            .el-upload.el-upload--text {
              width: 100%;
              height: 100%;
              .el-upload-dragger {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #bbbbbb;
                border-radius: 4px;
                &:hover {
                  border-color: #1c1c1c;
                }
                .file {
                  line-height: 20px;
                  margin-top: 5.68px;
                }
               .el-button {
                margin-top: 10px;
               }
              }
            }
          }
        }
        .photos-wrap {
          display: flex;
          flex-wrap: wrap;
          max-height: 322px;
          overflow: auto;
          margin-top: 20px;
          background: #f7f7f7;
          padding: 32px 0 0 32px;
          box-sizing: border-box;
          border: 1px dashed #bbbbbb;
          border-radius: 4px;
          .photo-box {
            position: relative;
            &.photo-box {
              margin-right: 20px;
            }
            .img {
              width: 86px;
              height: 86px;
              border: 1px solid #bbbbbb;
              border-radius: 4px;
              vertical-align: top;
            }
            .close {
              width: 20px;
              height: 20px;
              position: absolute;
              top: -10px;
              right: -10px;
              cursor: pointer;
            }
            .sku {
              line-height: 19px;
              max-width: 86px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 13px;
              color: #494949;
              font-weight: 400;
              margin-bottom: 18px;
            }
          }
        }
      }
      .btns {
        justify-content: center;
        margin-top: 30px;
        .el-button {
          width: 120px;
          height: 50px;
        }
        .el-button + .el-button {
          margin-left: 30px;
        }
      }
    }
  }
}
</style>
